module.exports = __webpack_public_path__ + "static/media/windows95-announcement.606af8e1.gif";